module.exports = __webpack_public_path__ + "static/media/msgOut.9cf1e294.ogg";